import Link from 'next/link';
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

export default function NotFoundPage() {
  return (
    <div className='flex min-h-[600px] items-center justify-center border-0 bg-transparent p-4'>
      <Card className='w-full max-w-md border-0 bg-transparent shadow-none'>
        <CardHeader>
          <CardTitle className='text-center'>
            <span className='text-6xl font-bold text-gray-800'>404</span>
          </CardTitle>
        </CardHeader>
        <CardContent className='space-y-4'>
          <p className='text-center text-sm text-gray-600'>
            Oops! The page you&apos;re looking for doesn&apos;t exist.
          </p>
        </CardContent>
        <CardFooter className='flex justify-center'>
          <Button variant='ghost'>
            <Link href='/'>Back to Home</Link>
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
}
